module.exports = __webpack_public_path__ + "media/mood Edit 1 Export 1.02beb2e0.wav";